// @flow
import { getCreator, deleteCreator, postCreator, putCreator } from '../../http';
import environment from '../../environment/index';

import type { Country, OnlineStore } from '../../entities';
import type { PostItemRequestApi } from '../bag/api';

export type ShoppingCartItemRequestApi = {
  amount: number;
  detail?: string;
  image?: string;
  imageId?: string;
  imageURI?: string;
  itemCategoryId: number;
  itemId?: number;
  name: string;
  originalPackaging: boolean;
  price: string;
  shipping?: string;
  url: string;
  volumeTier: string;
  weight?: string;
  serviceTier?: string;
  courierId?: string;
};

export type VirtualItem = {
  itemId: number;
  amount: number;
  detail?: string;
  image?: string;
  imageURI?: string;
  isShippingAutomatic?: boolean;
  itemCategoryId: number;
  name: string;
  onlineStore: OnlineStore;
  originalPackaging: boolean;
  price: string;
  shipping: string;
  url: string;
  volumeTier: string;
  weight?: string;
};

export type VirtualItemRequestApi = {
  purchaseCountry: Country;
  item: ShoppingCartItemRequestApi | PostItemRequestApi;
  shippingRequest: ShippingRequestApi;
};

export type ShippingItemRequestApi = {
  itemId: number;
  amount: number;
  isShippingAutomatic?: boolean;
  price: string;
  shipping?: string;
  url: string;
};

export type ShippingRequestApi = {
  purchaseCountry: Country;
  items: ShippingItemRequestApi[];
};

export type ShippingResponse = {
  itemId: number;
  shipping: string;
  onlineStore: OnlineStore;
};

export type ShoppingCartRequestApi = {
  purchaseCountry: Country;
  shoppingCartItems: ShoppingCartItemRequestApi[];
  originType?: string;
};

export const endpoints = Object.freeze({
  GET_SHOPPING_CART: `${environment.apiUrl}/shopping-cart`,
  POST_SHOPPING_CART_ITEM: `${environment.apiUrl}/shopping-cart`,
  PUT_SHOPPING_CART_ITEM: `${environment.apiUrl}/shopping-cart/:itemNumber`,
  DELETE_SHOPPING_CART_ITEM: `${environment.apiUrl}/shopping-cart/:itemNumber`,
  DELETE_SHOPPING_CART_ITEMS: `${environment.apiUrl}/shopping-cart/items`,
  DELETE_SHOPPING_CART: `${environment.apiUrl}/shopping-cart`,
  POST_ITEMS_AUTO_SHIPPING: `${environment.apiUrl}/shipping/auto-items`,
});

export const getShoppingCartApi = getCreator(fetch, endpoints.GET_SHOPPING_CART);
export const postShoppingCartItemApi = postCreator(fetch, endpoints.POST_SHOPPING_CART_ITEM);
export const putShoppingCartItemApi = putCreator(fetch, endpoints.PUT_SHOPPING_CART_ITEM);
export const deleteShoppingCartItemsApi = deleteCreator(fetch, endpoints.DELETE_SHOPPING_CART_ITEMS);
export const deleteShoppingCartItemApi = deleteCreator(fetch, endpoints.DELETE_SHOPPING_CART_ITEM);
export const deleteShoppingCartApi = deleteCreator(fetch, endpoints.DELETE_SHOPPING_CART);
export const postItemsAutoShippingApi = postCreator(fetch, endpoints.POST_ITEMS_AUTO_SHIPPING);



// WEBPACK FOOTER //
// ./src/modules/shopping-cart/api.js